import moment from 'app/modules/datetime';
import lang from 'app/lib/moment/lang/nl';

moment.lang('nl', lang);



// WEBPACK FOOTER //
// ./src/web/js/app/datetime.nl.js